import AdminsRepository from '@/repositories/AdminsRepository';
import CustomersRepository from '@/repositories/CustomersRepository';
import ReportsRepository from '@/repositories/ReportsRepository';
import LoansRepository from '@/repositories/LoansRepository';
import OfficersRepository from '@/repositories/OfficersRepository';
import OthersRepository from '@/repositories/OthersRepository';
import JournalsRepository from '@/repositories/JournalsRepository';
import NotesRepository from '@/repositories/NotesRepository';

export const ADMINS = 'admins';
export const CUSTOMERS = 'customers';
export const REPORTS = 'reports';
export const LOANS = 'loans';
export const LOAN_NOTES = 'loanNotes';
export const OFFICERS = 'officers';
export const OTHERS = 'others';
export const JOURNALS = 'journals';
export const NOTES = 'notes';

const repositories = {
  [ADMINS]: AdminsRepository,
  [CUSTOMERS]: CustomersRepository,
  [REPORTS]: ReportsRepository,
  [LOANS]: LoansRepository,
  [OFFICERS]: OfficersRepository,
  [OTHERS]: OthersRepository,
  [JOURNALS]: JournalsRepository,
  [NOTES]: NotesRepository,
};

export default {
  get: name => repositories[name],
};
